module.exports = __webpack_public_path__ + "static/media/dewpoint.9ac6d11f.svg";